import './resolve-dispute.modal.scss';

export default function ResolveDisputeModal($scope, close, $alert, $t, request) {
  'ngInject';

  $scope.resolveDispute = {
    resolutionType: 'resolve',
    refund: 50,
    transfer: 50,
    request: request,
    paidAmount: getPaidAmount(request)
  };

  $scope.transactionOptions = {
    min: 0,
    max: 100,
    step: 5,
    translate: value => value + '%'
  };

  $scope.ok = (form) => {
    if (form.$valid) {
      const result = {
        type: $scope.resolveDispute.resolutionType
      }

      if (result.type === 'partially_resolved') {
        result.request = {
          partialRefund: {
            enabled: true,
            percent: $scope.resolveDispute.refund
          },
          partialTransfer: {
            enabled: true,
            percent: $scope.resolveDispute.transfer
          }
        }
      }

      close(result);
    }
  };

  $scope.close = () => {
    close();
  };

  /**
   * Card bookings keep the customer's money on an authorization hold, so they have no charge to refund from —
   * their refund is a share of what the hold captured (or, while it is still uncaptured, of what it authorized).
   */
  function getPaidAmount(request) {
    const payments = (request || {}).paymentsDetails || {};
    const charge = payments.charge || {};

    if (charge.amount) {
      return charge.amount;
    }

    const hold = payments.hold || {};

    return hold.capturedAmount || hold.amount || 0;
  }

}